import { render, staticRenderFns } from "./SpotLightForm.vue?vue&type=template&id=c66fde96&"
import script from "./SpotLightForm.vue?vue&type=script&lang=ts&"
export * from "./SpotLightForm.vue?vue&type=script&lang=ts&"
import style0 from "./SpotLightForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports